import { useState } from "react";

import { Box, Typography, Modal, Grid } from "@mui/material";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/CloseRounded";

interface Props {
  error: boolean;
  message: string;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 250,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 5,
};

export const ModalError = (props: Props) => {
  const { error, message } = props;
  const [open, setOpen] = useState(error);
  const handleClose = () => setOpen(false);

  return (
    <div>
      {open && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container>
              <Grid
                item
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  p: 1,
                  bgcolor: "#f2f4f9",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Typography
              id="modal-modal-title"
              variant="h4"
              component="h2"
              sx={{ mt: 3, fontWeight: "bold" }}
            >
              Error
            </Typography>
            <Typography
              id="modal-modal-description"
              variant="h6"
              sx={{ mt: 1 }}
            >
              {message}
            </Typography>
          </Box>
        </Modal>
      )}
    </div>
  );
};
